import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import MyStorage from './util/storage';
import { Oval as Loader } from 'react-loader-spinner';
import { ToastContainer } from 'react-toastify';
import Api from './api/api';

const Quizzes = () => {
    const history = useNavigate();
    const [models, setModels] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setLoader(true);
        Api.getQuizzes(
            (response) => {
                setLoader(false);
                setModels(response);
            },
            () => {
                setLoader(false);
            }
        );
    };

    const editQuiz = (item) => {
        history('/admin/add-quiz', { state: { model: item } });
    };

    const deleteQuiz = (item) => {
        if (window.confirm('Are you sure you want to delete this quiz?')) {
            setModels(models.filter((m) => m.id !== item.id));
            Api.deleteQuiz(item.id);
        }
    };

    if (!MyStorage.isLogin()) {
        return null;
    }

    return (
        <div className='main' style={{ padding: 0 }}>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: 0 }}>
                <div style={{ color: 'blue' }}>Quizzes</div>
            </div>

            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
                <div style={{ padding: 20, display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'scroll' }}>
                    <Button
                        className='btn-block btn-dark'
                        style={{ marginTop: 0, fontSize: 16, backgroundColor: 'green', borderWidth: 0, height: 40, width: 300, alignSelf: 'center' }}
                        onClick={() => history('/admin/add-quiz', { state: { model: null } })}>
                        Add Quiz
                    </Button>

                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
                        {models.map((item, index) => (
                            <div key={item.id || index} style={{ width: '100%', backgroundColor: 'white', marginTop: 10, padding: 0, marginRight: 10 }}>
                                <div style={{ display: 'flex', backgroundColor: '#f2f2f2', padding: 10, alignItems: 'center' }}>
                                    {item.imageUrl && (
                                        <img
                                            src={item.imageUrl}
                                            alt={item.title}
                                            style={{ width: 100, height: 100, objectFit: 'cover', marginRight: 15, borderRadius: 4 }}
                                        />
                                    )}
                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                        <div style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 4 }}>{item.title}</div>
                                        <div style={{ fontSize: 13, color: '#555', marginBottom: 4 }}>{item.question}</div>
                                        <div style={{ fontSize: 12, color: '#888' }}>
                                            Options: {item.options?.join(', ')}
                                        </div>
                                        <div style={{ fontSize: 12, color: 'green' }}>
                                            Correct: {item.options?.[item.correctOptionIndex]}
                                        </div>
                                        <div style={{ fontSize: 12, color: '#444', marginTop: 4 }}>
                                            Bonus: {item.bonusFact}
                                        </div>
                                        <div style={{ marginTop: 10, display: 'flex' }}>
                                            <Button
                                                className='btn-block btn-dark'
                                                style={{ fontSize: 14, marginRight: 10, backgroundColor: 'gray', borderWidth: 0, height: 36, width: 80 }}
                                                onClick={() => editQuiz(item)}>
                                                Edit
                                            </Button>
                                            <Button
                                                className='btn-block btn-dark'
                                                style={{ fontSize: 14, backgroundColor: 'red', borderWidth: 0, height: 36, width: 80 }}
                                                onClick={() => deleteQuiz(item)}>
                                                Delete
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {loader && (
                <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
                    <div style={{ padding: 10, backgroundColor: 'red', borderRadius: 100 }}>
                        <Loader color="white" height={70} width={70} visible={true} />
                    </div>
                </div>
            )}

            <ToastContainer />
        </div>
    );
};

export default Quizzes;
